module.exports = __webpack_public_path__ + "img/chengyun3.157d65dc.png";